/**
 * Application translations - Side-by-side Arabic/English
 *
 * Format: 'key': { ar: 'Arabic', en: 'English' }
 */

export const translations = {
  // ==========================================================================
  // Common
  // ==========================================================================
  'common.appName':       { ar: 'مشروع الفا',         en: 'Project Alpha' },
  'common.loading':       { ar: 'جاري التحميل...',    en: 'Loading...' },
  'common.error':         { ar: 'حدث خطأ',           en: 'An error occurred' },
  'common.retry':         { ar: 'إعادة المحاولة',     en: 'Retry' },
  'common.back':          { ar: 'رجوع',              en: 'Back' },
  'common.next':          { ar: 'التالي',            en: 'Next' },
  'common.confirm':       { ar: 'تأكيد',             en: 'Confirm' },
  'common.cancel':        { ar: 'إلغاء',             en: 'Cancel' },
  'common.save':          { ar: 'حفظ',               en: 'Save' },
  'common.close':         { ar: 'إغلاق',             en: 'Close' },
  'common.search':        { ar: 'بحث',               en: 'Search' },
  'common.noResults':     { ar: 'لا توجد نتائج',      en: 'No results' },
  'common.viewDetails':   { ar: 'عرض التفاصيل',       en: 'View Details' },

  // ==========================================================================
  // Navigation
  // ==========================================================================
  'nav.home':             { ar: 'الرئيسية',          en: 'Home' },
  'nav.about':            { ar: 'عن المنصة',         en: 'About' },
  'nav.contact':          { ar: 'تواصل معنا',        en: 'Contact Us' },
  'nav.properties':       { ar: 'العقارات',          en: 'Properties' },

  // ==========================================================================
  // Footer
  // ==========================================================================
  'footer.tagline':       { ar: 'منصة التملك العقاري الرقمي الأولى في المملكة العربية السعودية',
                            en: 'The first digital real estate ownership platform in Saudi Arabia' },
  'footer.quickLinks':    { ar: 'روابط سريعة',       en: 'Quick Links' },
  'footer.support':       { ar: 'الدعم',             en: 'Support' },
  'footer.faq':           { ar: 'الأسئلة الشائعة',    en: 'FAQ' },
  'footer.terms':         { ar: 'الشروط والأحكام',    en: 'Terms & Conditions' },
  'footer.contactUs':     { ar: 'تواصل معنا',        en: 'Contact Us' },
  'footer.location':      { ar: 'الرياض، المملكة العربية السعودية',
                            en: 'Riyadh, Saudi Arabia' },
  'footer.copyright':     { ar: '© 2025 مشروع الفا. جميع الحقوق محفوظة.',
                            en: '© 2025 Project Alpha. All rights reserved.' },

  // ==========================================================================
  // Hero Section
  // ==========================================================================
  'hero.title':           { ar: 'امتلك منزل أحلامك',   en: 'Own Your Dream Home' },
  'hero.subtitle':        { ar: 'بخطوات رقمية بسيطة', en: 'With Simple Digital Steps' },
  'hero.description':     { ar: 'تملّك منزلك خلال ٣٠ دقيقة',
                            en: 'Own your home in 30 minutes' },

  // ==========================================================================
  // Stats
  // ==========================================================================
  'stats.availableProperties': { ar: 'عقارات متاحة',    en: 'Available Properties' },
  'stats.districtsInRiyadh':   { ar: 'أحياء في الرياض', en: 'Districts in Riyadh' },
  'stats.digital':             { ar: 'رقمي',           en: 'Digital' },

  // ==========================================================================
  // Properties
  // ==========================================================================
  'properties.available':         { ar: 'العقارات المتاحة',      en: 'Available Properties' },
  'properties.noProperties':      { ar: 'لا توجد عقارات',        en: 'No properties found' },
  'properties.tryDifferentFilters': { ar: 'جرب تغيير معايير البحث', en: 'Try changing your search criteria' },
  'properties.resetFilters':      { ar: 'إعادة تعيين الفلاتر',   en: 'Reset Filters' },
  'properties.bedrooms':          { ar: 'غرف نوم',              en: 'Bedrooms' },
  'properties.bathrooms':         { ar: 'حمامات',               en: 'Bathrooms' },
  'properties.sqm':               { ar: 'م²',                   en: 'sqm' },
  'properties.sar':               { ar: 'ر.س',                  en: 'SAR' },
  'properties.startPurchase':     { ar: 'ابدأ التملك',           en: 'Start Purchase' },
  'properties.buyNow':            { ar: 'اشتري الآن',            en: 'Buy Now' },
  'properties.price':             { ar: 'السعر',                en: 'Price' },
  'properties.monthlyPayment':    { ar: 'القسط الشهري التقريبي', en: 'Estimated Monthly Payment' },
  'properties.financeDuration':   { ar: 'مدة التمويل',          en: 'Finance Duration' },
  'properties.years':             { ar: 'سنة',                  en: 'years' },
  'properties.features':          { ar: 'مميزات العقار',        en: 'Property Features' },
  'properties.builtIn':           { ar: 'بناء',                 en: 'Built in' },
  'properties.notFound':          { ar: 'العقار غير موجود',      en: 'Property not found' },
  'properties.backToHome':        { ar: 'العودة للرئيسية',       en: 'Back to Home' },
  'properties.fullyDigital':      { ar: 'عملية رقمية 100% - بدون زيارة البنك',
                                    en: '100% digital process - No bank visit required' },

  // ==========================================================================
  // Filters
  // ==========================================================================
  'filters.title':            { ar: 'تصفية البحث',          en: 'Filter Search' },
  'filters.reset':            { ar: 'إعادة تعيين',          en: 'Reset' },
  'filters.searchPlaceholder': { ar: 'ابحث بالعنوان أو الحي...', en: 'Search by title or district...' },
  'filters.district':         { ar: 'الحي',                 en: 'District' },
  'filters.allDistricts':     { ar: 'جميع الأحياء',          en: 'All Districts' },
  'filters.propertyType':     { ar: 'نوع العقار',           en: 'Property Type' },
  'filters.allTypes':         { ar: 'جميع الأنواع',          en: 'All Types' },
  'filters.bedrooms':         { ar: 'عدد الغرف',            en: 'Bedrooms' },
  'filters.anyBedrooms':      { ar: 'أي عدد',               en: 'Any' },
  'filters.rooms':            { ar: 'غرف',                  en: 'Rooms' },
  'filters.roomsPlus':        { ar: 'غرف+',                 en: 'Rooms+' },
  'filters.priceRange':       { ar: 'نطاق السعر',           en: 'Price Range' },

  // ==========================================================================
  // Purchase Journey
  // ==========================================================================
  'purchase.confirmAppointment':   { ar: 'تأكيد الموعد',           en: 'Confirm Appointment' },
  'purchase.selectDate':           { ar: 'اختر التاريخ',           en: 'Select Date' },
  'purchase.selectTime':           { ar: 'اختر الوقت',             en: 'Select Time' },
  'purchase.congratulations':      { ar: 'مبروك!',                 en: 'Congratulations!' },
  'purchase.appointmentConfirmed': { ar: 'تم تأكيد موعد استلام المفتاح بنجاح',
                                     en: 'Your key pickup appointment has been confirmed' },
  'purchase.date':                 { ar: 'التاريخ',                en: 'Date' },
  'purchase.time':                 { ar: 'الوقت',                  en: 'Time' },
  'purchase.location':             { ar: 'الموقع',                 en: 'Location' },
  'purchase.backToHome':           { ar: 'العودة للرئيسية',         en: 'Back to Home' },
  'purchase.pickupKeyTitle':       { ar: 'حدد موعد استلام المفتاح', en: 'Schedule Key Pickup' },
  'purchase.pickupKeySubtitle':    { ar: 'اختر الوقت المناسب لاستلام مفتاح منزلك الجديد',
                                     en: 'Choose a convenient time to pick up your new home keys' },

  // ==========================================================================
  // Rental Agreement
  // ==========================================================================
  'rental.temporaryContract': { ar: 'عقد الإيجار المؤقت',     en: 'Temporary Rental Agreement' },
  'rental.subtitle':          { ar: 'اسكن في منزلك الجديد أثناء انتظار موافقة البنك',
                                en: 'Move into your new home while waiting for bank approval' },
  'rental.temporary':         { ar: 'عقد مؤقت',              en: 'Temporary Contract' },
  'rental.ejarApproved':      { ar: 'معتمد من إيجار',         en: 'Ejar Approved' },
  'rental.contractDetails':   { ar: 'تفاصيل العقد',          en: 'Contract Details' },
  'rental.tenant':            { ar: 'المستأجر',              en: 'Tenant' },
  'rental.duration':          { ar: 'مدة العقد',             en: 'Contract Duration' },
  'rental.months':            { ar: 'شهر',                   en: 'months' },
  'rental.startDate':         { ar: 'تاريخ البدء',           en: 'Start Date' },
  'rental.endDate':           { ar: 'تاريخ الانتهاء',         en: 'End Date' },
  'rental.monthlyRent':       { ar: 'الإيجار الشهري',        en: 'Monthly Rent' },
  'rental.totalRent':         { ar: 'إجمالي الإيجار',        en: 'Total Rent' },
  'rental.note':              { ar: 'هذا عقد إيجار مؤقت يتيح لك السكن في العقار أثناء انتظار الموافقة النهائية على التمويل العقاري. سيتم خصم مبلغ الإيجار من الدفعة الأولى عند اكتمال عملية الشراء.',
                                en: 'This is a temporary rental agreement that allows you to live in the property while waiting for final mortgage approval. The rental amount will be deducted from the down payment upon purchase completion.' },
  'rental.agreementText':     { ar: 'أقر بأنني قرأت شروط عقد الإيجار المؤقت وأوافق على الالتزام بسداد الإيجار الشهري المحدد خلال فترة العقد.',
                                en: 'I confirm that I have read the temporary rental agreement terms and agree to pay the specified monthly rent during the contract period.' },
  'rental.issueContract':     { ar: 'اصدار عقد الايجار المؤقت', en: 'Issue Rental Contract' },

  // ==========================================================================
  // Errors
  // ==========================================================================
  'error.propertiesLoad':     { ar: 'تعذر تحميل العقارات',    en: 'Failed to load properties' },
  'error.propertiesLoadDesc': { ar: 'حدث خطأ أثناء تحميل بيانات العقارات. يرجى المحاولة مرة أخرى.',
                                en: 'An error occurred while loading property data. Please try again.' },
  'error.purchaseProcess':    { ar: 'تعذر إتمام العملية',     en: 'Failed to complete process' },
  'error.purchaseProcessDesc': { ar: 'حدث خطأ أثناء عملية الشراء. لا تقلق، لم يتم إجراء أي تغييرات على حسابك. يرجى المحاولة مرة أخرى أو الاتصال بالدعم.',
                                 en: 'An error occurred during the purchase process. Don\'t worry, no changes were made to your account. Please try again or contact support.' },
  'error.stepFailed':         { ar: 'حدث خطأ',               en: 'An error occurred' },
  'error.stepFailedDesc':     { ar: 'لم نتمكن من إكمال هذه الخطوة. يرجى المحاولة مرة أخرى.',
                                en: 'We couldn\'t complete this step. Please try again.' },
  'error.forHelp':            { ar: 'للمساعدة:',             en: 'For help:' },

  // ==========================================================================
  // Accessibility
  // ==========================================================================
  'a11y.previousImage':       { ar: 'الصورة السابقة',        en: 'Previous image' },
  'a11y.nextImage':           { ar: 'الصورة التالية',        en: 'Next image' },
  'a11y.imageOf':             { ar: 'الصورة {{current}} من {{total}}',
                                en: 'Image {{current}} of {{total}}' },
  'a11y.switchToEnglish':     { ar: 'Switch to English',    en: 'Switch to English' },
  'a11y.switchToArabic':      { ar: 'التبديل إلى العربية',   en: 'التبديل إلى العربية' },
} as const;

// Type for translation keys
export type TranslationKey = keyof typeof translations;

/**
 * Transform translations to i18next resource format
 */
export function getI18nResources() {
  const ar: Record<string, string> = {};
  const en: Record<string, string> = {};

  for (const [key, value] of Object.entries(translations)) {
    ar[key] = value.ar;
    en[key] = value.en;
  }

  return {
    ar: { translation: ar },
    en: { translation: en },
  };
}
